<template>
  <div>
    <a-dropdown v-if="permission" :trigger="['click']">
      <span class="edit-review">
        <a-popover v-if="value" title="评审内容">
          <template slot="content">
            <p v-text="value" />
          </template>
          <a-tag color="green">已评审</a-tag>
        </a-popover>
        <a-tag v-else color="blue">未评审</a-tag>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item><a-tag color="blue" @click="onChange(false)">未评审</a-tag></a-menu-item>
        <a-menu-item><a-tag color="green" @click="onChange(true)">已评审</a-tag></a-menu-item>
      </a-menu>
    </a-dropdown>
    <span v-else>
      <a-popover v-if="value" title="评审内容">
        <template slot="content">
          <p v-text="value" />
        </template>
        <a-tag color="green">已评审</a-tag>
      </a-popover>
      <a-tag v-else color="blue">未评审</a-tag>
    </span>
    <a-modal v-model="visible" title="技术评审" :mask-closable="false" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
        <a-form-model-item label="内容" prop="content">
          <a-input v-model="form.content" type="textarea" :auto-size="{ minRows: 5, maxRows: 10 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { storyUpdateItem } from '@/api/project/story';
import { permissionRequired } from '@/utils/utils';
import { storyReviews } from '@/utils/dictionary';

export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    storyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      storyReviews,
      visible: false,
      form: {
        content: null
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      rules: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    permission() {
      return permissionRequired('project:requirement:edit', this.projectId);
    }
  },
  methods: {
    onChange(status) {
      if (status === true) {
        this.visible = true;
        this.form.content = this.value;
      } else {
        this.form.content = null;
        this.submitData();
      }
    },

    submitData() {
      if (this.value !== this.form.content) {
        storyUpdateItem({
          project_id: this.projectId,
          requirement_id: this.storyId,
          key: 'technical_review',
          value: this.form.content
        }).then(() => {
          this.visible = false;
          this.$message.success('更新成功');
          this.$emit('change');
        });
      } else {
        this.visible = false;
      }
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitData();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-review {
  cursor: pointer;
  display: inline-block;
  padding: 0 2px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-review:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
/deep/.ant-tag {
  margin-right: 0;
}
</style>
